import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { RsTemplateStatus } from '@/modules/__generated__/graphql/switchboard-generated';
import { getServicePurchaseUrl } from '@/modules/service-purchase/lib/get-service-purchase-url';
import { InternalLink } from '@/modules/shared/components/internal-link';
interface PurchaseButtonProps {
  serviceId: string;
  operatorId?: string | null;
  status?: RsTemplateStatus;
}
function PurchaseButton(t0) {
  const $ = _c(9);
  const {
    serviceId,
    operatorId,
    status
  } = t0;
  const isUnavailable = status === RsTemplateStatus.ComingSoon;
  let t1;
  if ($[0] !== operatorId || $[1] !== serviceId) {
    t1 = getServicePurchaseUrl(serviceId, {
      operatorId
    });
    $[0] = operatorId;
    $[1] = serviceId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isUnavailable && "pointer-events-none opacity-50";
  let t3;
  if ($[3] !== t2) {
    t3 = cn(t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isUnavailable || $[6] !== t1 || $[7] !== t3) {
    t4 = <InternalLink href={t1} disabled={isUnavailable} className={t3} size="lg" variant="default">Request a Quote</InternalLink>;
    $[5] = isUnavailable;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export { PurchaseButton };